import { put, takeLatest, all } from 'redux-saga/effects'

function* fetchSpends() {
  const remoteData = yield fetch(process.env.REACT_APP_API_URL)
    .then((response) => response.json())
    .then((data) => data)

  yield put({ type: 'SET_DATA', payload: remoteData })
}

function* watchFetchData() {
  yield takeLatest('GET_ASYNC_DATA', fetchSpends)
}

export default function* rootSaga() {
  yield all([ watchFetchData() ])
}
